import {DirectoryState} from './types';
import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

export const extraReducers = (
  builder: ActionReducerMapBuilder<DirectoryState>
) => {};
